import { Close } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

export const onOffChips = [
  { key: 'On', value: 1 },
  { key: 'Off', value: 0 },
];

export const notifRuleDescriptions: Record<string, string> = {
  balance_limit: 'Balance Limit',
  price_target: 'Alert when price was changed from last selected days, to current day, more than specified amount',
  backwardation:
    'Alert when market shifts into backwardation, signaling potential short-term supply tightness and impacting your exposure.',
  contango:
    'Alert when market shifts into contango, indicating potential long-term supply surplus and affecting your exposure.',
};

export const getClearBtn = (onClear: () => void) => (
  <InputAdornment position="end">
    <IconButton size="small" edge="end" onMouseDown={(e) => e.preventDefault()} onClick={onClear}>
      <Close fontSize="small" />
    </IconButton>
  </InputAdornment>
);
